export function getPayloadList(locos) {
  var locoList = [];
  var i = 0;
  for (i = 0; i < locos.length; i++) {
    locoList.push(locos[i].loconum);
  }
  return locoList;
}

export function getNewPayloadList(locos) {
  var locoList = [];
  var i = 0;
  for (i = 0; i < locos.length; i++) {
    locoList.push(locos[i].assetnum);
  }
  return locoList;
}
